/**
 * SVG path data for the chevrons left icon.
 */
export const chevronsLeft = {
    paths: [
        {
            d: 'M15.79 15.77a.75.75 0 0 1-1.06-.02l-5-5a.75.75 0 0 1 0-1.04l5-5.5a.75.75 0 1 1 1.12 1.04L11.414 10l4.436 4.75a.75.75 0 0 1-.06 1.02z',
            fillRule: 'evenodd',
            clipRule: 'evenodd',
        },
        {
            d: 'M9.79 15.77a.75.75 0 0 1-1.06-.02l-5-5a.75.75 0 0 1 0-1.04l5-5.5a.75.75 0 1 1 1.12 1.04L5.414 10l4.436 4.75a.75.75 0 0 1-.06 1.02z',
            fillRule: 'evenodd',
            clipRule: 'evenodd',
        },
    ],
};
//# sourceMappingURL=chevrons-left.js.map